// Croqui: `components/ListToolbar.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { type SegItem, Segmented } from './segmented.tsx';

/**
 * Barra acima de uma lista: abas (`Segmented`) e controles extras à esquerda, resumo
 * muted à direita. Se o resumo não couber ao lado das abas ele desce de linha, alinhado à
 * direita, em vez de sobrepor.
 */
export function ListToolbar({
  tabs,
  value,
  onChange,
  tabsLabel = 'Filtro da lista',
  extra,
  right,
  className,
}: {
  tabs?: SegItem[];
  value?: string;
  onChange?: (id: string) => void;
  tabsLabel?: string;
  extra?: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-3', className)}>
      <div className="flex min-w-0 flex-auto items-center gap-2.5">
        {tabs !== undefined && (
          <Segmented
            items={tabs}
            value={value ?? ''}
            label={tabsLabel}
            {...(onChange === undefined ? {} : { onChange })}
          />
        )}
        {extra}
      </div>
      {right !== undefined && (
        <span className="ml-auto shrink-0 whitespace-nowrap text-12 text-muted">{right}</span>
      )}
    </div>
  );
}
